import { apiClient } from "../apiClient";
import { lopHocApi } from "./lopHocApi";
import {
    CreateOrUpdateLopHocRequest,
    GetLopHocListParams,
    LopHocLichHocItem,
    LopHocLichThiItem,
    MoLopRequest,
    SaveLichHocRequest,
    SaveLichThiRequest,
} from "./LopHocModels";

export const lopHocService = {
    getList: async (params?: GetLopHocListParams) => {
        return await apiClient.get(lopHocApi.GET_LIST, { params });
    },

    createOrUpdate: async (data: CreateOrUpdateLopHocRequest) => {
        return await apiClient.post(lopHocApi.CREATE_OR_UPDATE, data);
    },

    delete: async (id: number) => {
        return await apiClient.post(lopHocApi.DELETE(id));
    },

    getLichHocByLop: async (id: number) => {
        return await apiClient.get(lopHocApi.GET_LICH_HOC(id)) as any;
    },

    getLichThiByLop: async (id: number) => {
        return await apiClient.get(lopHocApi.GET_LICH_THI(id)) as any;
    },

    saveLichHoc: async (data: SaveLichHocRequest) => {
        return await apiClient.post(lopHocApi.SAVE_LICH_HOC, data);
    },

    sendLichHocEmail: async (idLop: number) => {
        return await apiClient.post(lopHocApi.SEND_LICH_HOC_EMAIL(idLop));
    },

    saveLichThi: async (data: SaveLichThiRequest) => {
        return await apiClient.post(lopHocApi.SAVE_LICH_THI, data);
    },

    sendLichThiEmail: async (idLop: number) => {
        return await apiClient.post(lopHocApi.SEND_LICH_THI_EMAIL(idLop));
    },

    moLop: async (data: MoLopRequest) => {
        return await apiClient.post(lopHocApi.MO_LOP, data);
    },
    getOpenEmailResults: async (idLop:number) => apiClient.get(`BSKTLopHoc/open-email-results/${idLop}`),
    getNganhGanDungList: async () => {
        return await apiClient.get(lopHocApi.GET_NGANH_GAN_DUNG_LIST);
    },

    getMonHocByNganhGanDung: async (id: number) => {
        return await apiClient.get(lopHocApi.GET_MON_HOC_BY_NGANH_GAN_DUNG(id));
    },
};
